/* eslint-disable array-callback-return */
import OutlineButton from "components/Button/OutlineButton";
import { Modal, Row, Col } from "antd";
import { Flex, Box } from "@chakra-ui/react";
import CardPerson from "ui/components/Cards/CardPerson";
import useDetalheEncomenda from "core/features/encomenda/hooks/useDetalheEncomenda";
import ContentItem from "components/ContentDetalheConta/components/ContentItem";
import moment from "moment";
import { Progress } from "@chakra-ui/react";
import { HiPhone } from "react-icons/hi";
import { BsFillChatDotsFill } from "react-icons/bs";
import colors from "core/resources/theme/colors";
import { getProgressForEvent } from "../util/index";
import { Tooltip } from "antd";
import { BsFillPersonFill } from "react-icons/bs";
import { IoMdMail } from "react-icons/io";
import { formatPhone } from "infra/helpers/number";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import { EncomendaStatusEnum } from "core/features/encomenda/typings";
import { showConfirm } from "infra/helpers/alerta";
import useProgredirStatus from "core/features/encomenda/hooks/useProgredirStatus";
import { useMensagemModal } from "ui/components/DrawerNovaMensagem/MensagemModalContext";
import { TipoDestinoEnum } from "core/features/documentos/enums";
import { AssuntoMensagem } from "core/features/mensagens/typings";
import { useLoading } from "components/GlobalLoading/index";
import { AnexoItem } from "ui/components/Anexos";
import useHasPermission from "core/features/permissions/hooks/useHasPermission";
import { PermissaoEnum } from "core/resources/enums/permissao";

interface ModalHistoricoAtualEncomendaProps {
  isOpenModal: boolean;
  onClose: () => any;
  id: string | undefined;
  refetchList?: () => any;
  onDeleteEncomenda?: (id: string) => any;
}

export default function ModalHistoricoAtualEncomenda({
  id,
  isOpenModal,
  onClose,
  refetchList,
  onDeleteEncomenda,
}: ModalHistoricoAtualEncomendaProps) {
  const { data, refetch, isLoading, isFetching } = useDetalheEncomenda(id);
  const { mutate, isLoading: isLoadingProgressStatus } = useProgredirStatus();
  const { openWithDefaultValues } = useMensagemModal();
  const hasPermissaoExcluir = useHasPermission(
    PermissaoEnum.Backoffice.Administrativo.Encomenda.Excluir
  );

  useLoading(isLoading || isFetching);

  const onProgredirStatus = (proximoStatusId?: EncomendaStatusEnum) => {
    let msg = "";

    if (
      [
        EncomendaStatusEnum.RecebidaNaPortaria,
        EncomendaStatusEnum.EntregueAoMorador,
      ].includes(data?.status.id!)
    ) {
      msg = "Confirmar recebimento pelo morador?";
    } else if (
      proximoStatusId === EncomendaStatusEnum.RecebidaNaSalaDeEncomendas
    ) {
      msg = "Confirmar recebimento na sala de encomendas?";
    } else {
      msg = "Confirmar recebimento na portaria?";
    }

    showConfirm("Após a confirmação essa informação não poderá ser alterada!", {
      title: msg,
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        mutate(
          { id: id!, proximoStatusId },
          {
            onSuccess: () => {
              refetch?.();
              refetchList?.();
            },
          }
        );
      }
    });
  };

  return (
    <>
      <Modal
        destroyOnClose
        width={"600px"}
        onCancel={onClose}
        centered
        title="Status da encomenda"
        visible={isOpenModal}
        footer={
          <Flex justifyContent="end" gap={4}>
            <OutlineButton onClick={onClose}>Fechar</OutlineButton>
            {!!id && !!onDeleteEncomenda && hasPermissaoExcluir ? (
              <PrimaryButton
                bgColor="red.500"
                onClick={() => onDeleteEncomenda?.(id)}
              >
                Excluir
              </PrimaryButton>
            ) : null}
          </Flex>
        }
      >
        <Box as={Row}>
          <Flex as={Col} md={24} mb={4} alignItems="center">
            <CardPerson
              avatarProps={{ opacity: 1 }}
              avatarUrl={data?.pessoa.imagemUrl || ""}
              nome={data?.pessoa.nome || ""}
              subtitle={`${data?.unidade.numero || ""} ${
                data?.unidade.blocoQuadra
                  ? `, ${data?.unidade.blocoQuadra}`
                  : ""
              } `}
              border="1px solid gray"
            />

            <Flex gap={4}>
              <Flex cursor="pointer">
                <Tooltip
                  overlayInnerStyle={{ width: "max-content" }}
                  placement="bottomRight"
                  color="#eff4ff"
                  title={
                    <Flex flexDirection="column" color="black" p={2}>
                      <Flex align="center" gap={2}>
                        <BsFillPersonFill color={colors.primaryLight} />
                        {data?.pessoa.nome}
                      </Flex>
                      {data?.pessoa.celular ? (
                        <Flex align="center" gap={2}>
                          <HiPhone color={colors.primaryLight} />
                          {formatPhone(data?.pessoa.celular)}
                        </Flex>
                      ) : null}

                      <Flex align="center" gap={2}>
                        <IoMdMail color={colors.primaryLight} />
                        {data?.pessoa.email}
                      </Flex>
                    </Flex>
                  }
                >
                  <HiPhone size={20} color={colors.primaryLight} />
                </Tooltip>
              </Flex>
              <Flex
                margin="auto"
                cursor="pointer"
                onClick={() =>
                  openWithDefaultValues(
                    {
                      tipoDestinoId: TipoDestinoEnum.UmaUnidade,
                      destinoId: data?.unidade.id,
                      destinos: [
                        {
                          tipoDestinoId: TipoDestinoEnum.UmaUnidade,
                          destinoId: data?.unidade.id!,
                          label: "Essa unidade",
                        },
                      ],
                      assuntoId: AssuntoMensagem.Outros,
                      assuntoCustomizado: `Sobre a encomenda ${data?.descricao}`,
                    },
                    undefined,
                    true
                  )
                }
              >
                <BsFillChatDotsFill size={20} color={colors.primaryLight} />
              </Flex>
            </Flex>
          </Flex>
        </Box>
        <Box mb={4}>
          <ContentItem
            titulo="DESCRIÇÃO DA ENTREGA:"
            descricao={data?.descricao || ""}
          />
        </Box>
        <Box mb={4}>
          <ContentItem
            titulo="CADASTRADA EM:"
            descricao={moment(data?.createdAt).format("DD/MM/YYYY") || ""}
          />
        </Box>
        <Box mb={4}>
          <ContentItem titulo="CRIADO POR:" descricao={data?.origem || ""} />
        </Box>
        <Box mb={4}>
          <ContentItem
            titulo="STATUS DA ENTREGA:"
            descricao={data?.status.nome || ""}
          />
        </Box>
        <Box mb={8}>
          <ContentItem titulo="ANOTAÇÕES:" descricao={data?.observacao || ""} />
        </Box>
        <Box>
          {data?.arquivos?.length ? (
            <Box mt="8px" mb="16px">
              <ContentItem titulo="ARQUIVOS" />
              <Flex gridGap={2}>
                {data?.arquivos.map((anexo, indexFiles) => (
                  <AnexoItem
                    key={indexFiles}
                    url={anexo.referencia}
                    nome={anexo.nome}
                  />
                ))}
              </Flex>
            </Box>
          ) : null}
        </Box>
        <Box mb={4} px={4}>
          <Progress
            value={getProgressForEvent(data?.status.id)}
            colorScheme={
              getProgressForEvent(data?.status.id) === 100 ? "green" : undefined
            }
          />
        </Box>

        <Box>
          <Flex justifyContent="center">
            {[
              EncomendaStatusEnum.RecebidaNaPortaria,
              EncomendaStatusEnum.RecebidaNaSalaDeEncomendas,
              EncomendaStatusEnum.AguardandoRecebimento,
            ].includes(data?.status.id as any) ||
            (data?.status.id === EncomendaStatusEnum.EntregueAoMorador &&
              data?.condominioPodeConfirmar) ? (
              <Flex gap={4} justifyContent="center" w="100%">
                <PrimaryButton
                  isLoading={isLoadingProgressStatus}
                  onClick={() => onProgredirStatus()}
                >
                  {data?.status.id
                    ? statusMap[data?.status.id!]
                    : "Progredir status"}
                </PrimaryButton>

                {data?.status?.id ===
                EncomendaStatusEnum.AguardandoRecebimento ? (
                  <PrimaryButton
                    isLoading={isLoadingProgressStatus}
                    onClick={() =>
                      onProgredirStatus(
                        EncomendaStatusEnum.RecebidaNaSalaDeEncomendas
                      )
                    }
                  >
                    Recebido na sala de encomendas
                  </PrimaryButton>
                ) : null}
              </Flex>
            ) : null}
          </Flex>
        </Box>
      </Modal>
    </>
  );
}

const statusMap = {
  [EncomendaStatusEnum.RecebidaNaPortaria]: "Entregue ao morador",
  [EncomendaStatusEnum.RecebidaNaSalaDeEncomendas]: "Entregue ao morador",
  [EncomendaStatusEnum.EntregueAoMorador]: "Confirmar recebimento pelo morador",
  [EncomendaStatusEnum.AguardandoRecebimento]: "Recebido na portaria",
  [EncomendaStatusEnum.EntregaConfirmadaPeloMorador]: "Confirmado!",
};
